// extracted by mini-css-extract-plugin
export default {"last-updated":"LastUpdate_last-updated__M002-","last-updated-top":"LastUpdate_last-updated-top__m6CEK","last-updated-bottom":"LastUpdate_last-updated-bottom__rG1u1"};